const fill = {
  name: "fill",
  path: "/fill",
  title: "fill",
  description: "Utilities for styling the fill of SVG elements.",
  value: {
  "fill": {
    "fill-none": "none",
    "fill-color-inherit": "inherit",
    "fill-color-current": "currentColor",
    "fill-color-transparent": "transparent",
    "fill-color-[<value>]": "<value>",
    "fill-color-black": "var(--color-black)",
    "fill-color-white": "var(--color-white)",
    "fill-color-red-50": "var(--color-red-50)",
    "fill-color-red-100": "var(--color-red-100)",
    "fill-color-red-200": "var(--color-red-200)",
    "fill-color-red-300": "var(--color-red-300)",
    "fill-color-red-400": "var(--color-red-400)",
    "fill-color-red-500": "var(--color-red-500)",
    "fill-color-red-600": "var(--color-red-600)",
    "fill-color-red-700": "var(--color-red-700)",
    "fill-color-red-800": "var(--color-red-800)",
    "fill-color-red-900": "var(--color-red-900)",
    "fill-color-orange-50": "var(--color-orange-50)",
    "fill-color-orange-100": "var(--color-orange-100)",
    "fill-color-orange-200": "var(--color-orange-200)",
    "fill-color-orange-300": "var(--color-orange-300)",
    "fill-color-orange-400": "var(--color-orange-400)",
    "fill-color-orange-500": "var(--color-orange-500)",
    "fill-color-orange-600": "var(--color-orange-600)",
    "fill-color-orange-700": "var(--color-orange-700)",
    "fill-color-orange-800": "var(--color-orange-800)",
    "fill-color-orange-900": "var(--color-orange-900)",
    "fill-color-amber-50": "var(--color-amber-50)",
    "fill-color-amber-100": "var(--color-amber-100)",
    "fill-color-amber-200": "var(--color-amber-200)",
    "fill-color-amber-300": "var(--color-amber-300)",
    "fill-color-amber-400": "var(--color-amber-400)",
    "fill-color-amber-500": "var(--color-amber-500)",
    "fill-color-amber-600": "var(--color-amber-600)",
    "fill-color-amber-700": "var(--color-amber-700)",
    "fill-color-amber-800": "var(--color-amber-800)",
    "fill-color-amber-900": "var(--color-amber-900)",
    "fill-color-yellow-50": "var(--color-yellow-50)",
    "fill-color-yellow-100": "var(--color-yellow-100)",
    "fill-color-yellow-200": "var(--color-yellow-200)",
    "fill-color-yellow-300": "var(--color-yellow-300)",
    "fill-color-yellow-400": "var(--color-yellow-400)",
    "fill-color-yellow-500": "var(--color-yellow-500)",
    "fill-color-yellow-600": "var(--color-yellow-600)",
    "fill-color-yellow-700": "var(--color-yellow-700)",
    "fill-color-yellow-800": "var(--color-yellow-800)",
    "fill-color-yellow-900": "var(--color-yellow-900)",
    "fill-color-lime-50": "var(--color-lime-50)",
    "fill-color-lime-100": "var(--color-lime-100)",
    "fill-color-lime-200": "var(--color-lime-200)",
    "fill-color-lime-300": "var(--color-lime-300)",
    "fill-color-lime-400": "var(--color-lime-400)",
    "fill-color-lime-500": "var(--color-lime-500)",
    "fill-color-lime-600": "var(--color-lime-600)",
    "fill-color-lime-700": "var(--color-lime-700)",
    "fill-color-lime-800": "var(--color-lime-800)",
    "fill-color-lime-900": "var(--color-lime-900)",
    "fill-color-green-50": "var(--color-green-50)",
    "fill-color-green-100": "var(--color-green-100)",
    "fill-color-green-200": "var(--color-green-200)",
    "fill-color-green-300": "var(--color-green-300)",
    "fill-color-green-400": "var(--color-green-400)",
    "fill-color-green-500": "var(--color-green-500)",
    "fill-color-green-600": "var(--color-green-600)",
    "fill-color-green-700": "var(--color-green-700)",
    "fill-color-green-800": "var(--color-green-800)",
    "fill-color-green-900": "var(--color-green-900)",
    "fill-color-emerald-50": "var(--color-emerald-50)",
    "fill-color-emerald-100": "var(--color-emerald-100)",
    "fill-color-emerald-200": "var(--color-emerald-200)",
    "fill-color-emerald-300": "var(--color-emerald-300)",
    "fill-color-emerald-400": "var(--color-emerald-400)",
    "fill-color-emerald-500": "var(--color-emerald-500)",
    "fill-color-emerald-600": "var(--color-emerald-600)",
    "fill-color-emerald-700": "var(--color-emerald-700)",
    "fill-color-emerald-800": "var(--color-emerald-800)",
    "fill-color-emerald-900": "var(--color-emerald-900)",
    "fill-color-teal-50": "var(--color-teal-50)",
    "fill-color-teal-100": "var(--color-teal-100)",
    "fill-color-teal-200": "var(--color-teal-200)",
    "fill-color-teal-300": "var(--color-teal-300)",
    "fill-color-teal-400": "var(--color-teal-400)",
    "fill-color-teal-500": "var(--color-teal-500)",
    "fill-color-teal-600": "var(--color-teal-600)",
    "fill-color-teal-700": "var(--color-teal-700)",
    "fill-color-teal-800": "var(--color-teal-800)",
    "fill-color-teal-900": "var(--color-teal-900)",
    "fill-color-cyan-50": "var(--color-cyan-50)",
    "fill-color-cyan-100": "var(--color-cyan-100)",
    "fill-color-cyan-200": "var(--color-cyan-200)",
    "fill-color-cyan-300": "var(--color-cyan-300)",
    "fill-color-cyan-400": "var(--color-cyan-400)",
    "fill-color-cyan-500": "var(--color-cyan-500)",
    "fill-color-cyan-600": "var(--color-cyan-600)",
    "fill-color-cyan-700": "var(--color-cyan-700)",
    "fill-color-cyan-800": "var(--color-cyan-800)",
    "fill-color-cyan-900": "var(--color-cyan-900)",
    "fill-color-sky-50": "var(--color-sky-50)",
    "fill-color-sky-100": "var(--color-sky-100)",
    "fill-color-sky-200": "var(--color-sky-200)",
    "fill-color-sky-300": "var(--color-sky-300)",
    "fill-color-sky-400": "var(--color-sky-400)",
    "fill-color-sky-500": "var(--color-sky-500)",
    "fill-color-sky-600": "var(--color-sky-600)",
    "fill-color-sky-700": "var(--color-sky-700)",
    "fill-color-sky-800": "var(--color-sky-800)",
    "fill-color-sky-900": "var(--color-sky-900)",
    "fill-color-blue-50": "var(--color-blue-50)",
    "fill-color-blue-100": "var(--color-blue-100)",
    "fill-color-blue-200": "var(--color-blue-200)",
    "fill-color-blue-300": "var(--color-blue-300)",
    "fill-color-blue-400": "var(--color-blue-400)",
    "fill-color-blue-500": "var(--color-blue-500)",
    "fill-color-blue-600": "var(--color-blue-600)",
    "fill-color-blue-700": "var(--color-blue-700)",
    "fill-color-blue-800": "var(--color-blue-800)",
    "fill-color-blue-900": "var(--color-blue-900)",
    "fill-color-indigo-50": "var(--color-indigo-50)",
    "fill-color-indigo-100": "var(--color-indigo-100)",
    "fill-color-indigo-200": "var(--color-indigo-200)",
    "fill-color-indigo-300": "var(--color-indigo-300)",
    "fill-color-indigo-400": "var(--color-indigo-400)",
    "fill-color-indigo-500": "var(--color-indigo-500)",
    "fill-color-indigo-600": "var(--color-indigo-600)",
    "fill-color-indigo-700": "var(--color-indigo-700)",
    "fill-color-indigo-800": "var(--color-indigo-800)",
    "fill-color-indigo-900": "var(--color-indigo-900)",
    "fill-color-violet-50": "var(--color-violet-50)",
    "fill-color-violet-100": "var(--color-violet-100)",
    "fill-color-violet-200": "var(--color-violet-200)",
    "fill-color-violet-300": "var(--color-violet-300)",
    "fill-color-violet-400": "var(--color-violet-400)",
    "fill-color-violet-500": "var(--color-violet-500)",
    "fill-color-violet-600": "var(--color-violet-600)",
    "fill-color-violet-700": "var(--color-violet-700)",
    "fill-color-violet-800": "var(--color-violet-800)",
    "fill-color-violet-900": "var(--color-violet-900)",
    "fill-color-purple-50": "var(--color-purple-50)",
    "fill-color-purple-100": "var(--color-purple-100)",
    "fill-color-purple-200": "var(--color-purple-200)",
    "fill-color-purple-300": "var(--color-purple-300)",
    "fill-color-purple-400": "var(--color-purple-400)",
    "fill-color-purple-500": "var(--color-purple-500)",
    "fill-color-purple-600": "var(--color-purple-600)",
    "fill-color-purple-700": "var(--color-purple-700)",
    "fill-color-purple-800": "var(--color-purple-800)",
    "fill-color-purple-900": "var(--color-purple-900)",
    "fill-color-fuchsia-50": "var(--color-fuchsia-50)",
    "fill-color-fuchsia-100": "var(--color-fuchsia-100)",
    "fill-color-fuchsia-200": "var(--color-fuchsia-200)",
    "fill-color-fuchsia-300": "var(--color-fuchsia-300)",
    "fill-color-fuchsia-400": "var(--color-fuchsia-400)",
    "fill-color-fuchsia-500": "var(--color-fuchsia-500)",
    "fill-color-fuchsia-600": "var(--color-fuchsia-600)",
    "fill-color-fuchsia-700": "var(--color-fuchsia-700)",
    "fill-color-fuchsia-800": "var(--color-fuchsia-800)",
    "fill-color-fuchsia-900": "var(--color-fuchsia-900)",
    "fill-color-pink-50": "var(--color-pink-50)",
    "fill-color-pink-100": "var(--color-pink-100)",
    "fill-color-pink-200": "var(--color-pink-200)",
    "fill-color-pink-300": "var(--color-pink-300)",
    "fill-color-pink-400": "var(--color-pink-400)",
    "fill-color-pink-500": "var(--color-pink-500)",
    "fill-color-pink-600": "var(--color-pink-600)",
    "fill-color-pink-700": "var(--color-pink-700)",
    "fill-color-pink-800": "var(--color-pink-800)",
    "fill-color-pink-900": "var(--color-pink-900)",
    "fill-color-rose-50": "var(--color-rose-50)",
    "fill-color-rose-100": "var(--color-rose-100)",
    "fill-color-rose-200": "var(--color-rose-200)",
    "fill-color-rose-300": "var(--color-rose-300)",
    "fill-color-rose-400": "var(--color-rose-400)",
    "fill-color-rose-500": "var(--color-rose-500)",
    "fill-color-rose-600": "var(--color-rose-600)",
    "fill-color-rose-700": "var(--color-rose-700)",
    "fill-color-rose-800": "var(--color-rose-800)",
    "fill-color-rose-900": "var(--color-rose-900)",
    "fill-color-slate-50": "var(--color-slate-50)",
    "fill-color-slate-100": "var(--color-slate-100)",
    "fill-color-slate-200": "var(--color-slate-200)",
    "fill-color-slate-300": "var(--color-slate-300)",
    "fill-color-slate-400": "var(--color-slate-400)",
    "fill-color-slate-500": "var(--color-slate-500)",
    "fill-color-slate-600": "var(--color-slate-600)",
    "fill-color-slate-700": "var(--color-slate-700)",
    "fill-color-slate-800": "var(--color-slate-800)",
    "fill-color-slate-900": "var(--color-slate-900)",
    "fill-color-gray-50": "var(--color-gray-50)",
    "fill-color-gray-100": "var(--color-gray-100)",
    "fill-color-gray-200": "var(--color-gray-200)",
    "fill-color-gray-300": "var(--color-gray-300)",
    "fill-color-gray-400": "var(--color-gray-400)",
    "fill-color-gray-500": "var(--color-gray-500)",
    "fill-color-gray-600": "var(--color-gray-600)",
    "fill-color-gray-700": "var(--color-gray-700)",
    "fill-color-gray-800": "var(--color-gray-800)",
    "fill-color-gray-900": "var(--color-gray-900)",
    "fill-color-zinc-50": "var(--color-zinc-50)",
    "fill-color-zinc-100": "var(--color-zinc-100)",
    "fill-color-zinc-200": "var(--color-zinc-200)",
    "fill-color-zinc-300": "var(--color-zinc-300)",
    "fill-color-zinc-400": "var(--color-zinc-400)",
    "fill-color-zinc-500": "var(--color-zinc-500)",
    "fill-color-zinc-600": "var(--color-zinc-600)",
    "fill-color-zinc-700": "var(--color-zinc-700)",
    "fill-color-zinc-800": "var(--color-zinc-800)",
    "fill-color-zinc-900": "var(--color-zinc-900)",
    "fill-color-neutral-50": "var(--color-neutral-50)",
    "fill-color-neutral-100": "var(--color-neutral-100)",
    "fill-color-neutral-200": "var(--color-neutral-200)",
    "fill-color-neutral-300": "var(--color-neutral-300)",
    "fill-color-neutral-400": "var(--color-neutral-400)",
    "fill-color-neutral-500": "var(--color-neutral-500)",
    "fill-color-neutral-600": "var(--color-neutral-600)",
    "fill-color-neutral-700": "var(--color-neutral-700)",
    "fill-color-neutral-800": "var(--color-neutral-800)",
    "fill-color-neutral-900": "var(--color-neutral-900)",
    "fill-color-stone-50": "var(--color-stone-50)",
    "fill-color-stone-100": "var(--color-stone-100)",
    "fill-color-stone-200": "var(--color-stone-200)",
    "fill-color-stone-300": "var(--color-stone-300)",
    "fill-color-stone-400": "var(--color-stone-400)",
    "fill-color-stone-500": "var(--color-stone-500)",
    "fill-color-stone-600": "var(--color-stone-600)",
    "fill-color-stone-700": "var(--color-stone-700)",
    "fill-color-stone-800": "var(--color-stone-800)",
    "fill-color-stone-900": "var(--color-stone-900)"
  }
},
  exampleData: [
    {
      example: {
        code: `<svg class="fill-color-blue-500 hover:fill-color-red-500 ...">
  <!-- ... -->
</svg>
        `
      }
    },
    {
      example: {
        code: `<div class="text-color-purple-500 ...">
   <svg class="fill-color-current" >
   <!-- ... -->
   </svg>
</div>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">fill-color-*</code> to change the fill color of an SVG:
      </p>
      
      <div class="flex items-center justify-center">
   <svg class="h-12 fill-color-blue-500 hover:fill-color-red-500" viewBox="0 0 46 48">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.0002 0C12.5068 0 4.00017 8.50659 4.00017 19V32.5335C4.00017 32.8383 3.9145 33.1371 3.75292 33.3956L0.912672 37.94C0.0801118 39.2721 1.0378 41 2.60867 41H43.3917C44.9625 41 45.9202 39.2721 45.0877 37.94L42.2474 33.3956C42.0858 33.1371 42.0002 32.8383 42.0002 32.5335V19C42.0002 8.50659 33.4936 0 23.0002 0ZM23.0002 48C20.2388 48 18.0002 45.7614 18.0002 43H28.0002C28.0002 45.7614 25.7616 48 23.0002 48Z"></path>
   </svg>
</div>
    `
  },
      {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">fill-color-current</code> utility to set the fill color to the current text color:
      </p>
      
      <div class="flex items-center justify-center text-color-purple-500">
   <svg class="h-12 fill-color-current" viewBox="0 0 46 48">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.0002 0C12.5068 0 4.00017 8.50659 4.00017 19V32.5335C4.00017 32.8383 3.9145 33.1371 3.75292 33.3956L0.912672 37.94C0.0801118 39.2721 1.0378 41 2.60867 41H43.3917C44.9625 41 45.9202 39.2721 45.0877 37.94L42.2474 33.3956C42.0858 33.1371 42.0002 32.8383 42.0002 32.5335V19C42.0002 8.50659 33.4936 0 23.0002 0ZM23.0002 48C20.2388 48 18.0002 45.7614 18.0002 43H28.0002C28.0002 45.7614 25.7616 48 23.0002 48Z"></path>
   </svg>
</div>
    `
  }
]
}
export default fill;

<div class="sr-only fill-color-blue-500 hover:fill-color-red-500 fill-color-current text-color-purple-500">

</div>